import { renderPage } from "renderPage"
import { AccountBoatIndexPage } from "./Page"

renderPage({ component: AccountBoatIndexPage })
